import whatsNewSource from './whatsNew.txt';

/*
 * The "what's new" entries of the dashboard card, read from the text
 * file next door — a list to maintain by hand should be a plain text
 * file, not a data structure to edit around (see whatsNew.txt for the
 * format). Webpack hands the file over as a string (asset/source),
 * jest through test/rawTextTransform.cjs.
 *
 * An entry is a stamp line followed by one line per language. The
 * stamp is the last commit of the topic the entry summarises, with its
 * timezone, so the card can show the moment in the timezone of whoever
 * reads it rather than in the one it was written in.
 *
 * Malformed lines are dropped rather than shown: a typo in the file
 * must not put a broken row on everyone's dashboard.
 */
const STAMP = /^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2})(Z|[+-]\d{2}:?\d{2})?$/;
const TEXT = /^([a-z]{2})\s*\|\s*(\S.*)$/;

function parse(source) {
  const entries = [];
  let current = null;

  for (const raw of source.split('\n')) {
    const line = raw.trim();
    if (!line || line.startsWith('#')) continue;

    const stamp = STAMP.exec(line);
    if (stamp) {
      const [, date, time, zone] = stamp;
      current = { at: `${date} ${time}${zone || 'Z'}`, date, texts: {} };
      entries.push(current);
      continue;
    }

    /* a text line without a stamp above it belongs to no entry */
    const text = current && TEXT.exec(line);
    if (text) current.texts[text[1]] = text[2].trim();
  }

  return (
    entries
      /* an entry whose languages are all missing has nothing to say */
      .filter((entry) => Object.keys(entry.texts).length > 0)
      /* newest first, regardless of the order in the file */
      .sort((a, b) => b.at.localeCompare(a.at))
  );
}

export const whatsNewEntries = parse(whatsNewSource);

/*
 * The entry in the language of the session. A missing translation
 * falls back to any language the entry does carry — a gap in the file
 * should cost the reader a foreign sentence, not the whole line.
 */
export function whatsNewText(entry, language) {
  const short = (language || '').slice(0, 2).toLowerCase();
  return entry.texts[short] ?? Object.values(entry.texts)[0];
}
